import "babel-polyfill";
import "whatwg-fetch";
import 'url-search-params-polyfill';

import React, {useContext} from "react";
import {SearchContext} from "./SearchContext.js";

const BookPackOriginatorLink = ({ creator, type="auth", noLink=false }) => {
    
    let { doCustomSearch, doSearchTermSearch } = useContext(SearchContext);

    if(noLink) {
        return <><span>{creator} packs</span></>;
    } else {
        return <>
            {type != "other" && <a href="#" onClick={e => {
                e.preventDefault();
                if (type == "auth") {
                    doCustomSearch([
                        { filter: "filters[searchTerm][auth][term]", value: creator },
                        { filter: "filters[format][bookPacks][checked]", value: "1" }
                    ]);
                } else {
                    doSearchTermSearch(creator, type);
                }
            }}>{creator} packs</a>}
            {type == "other" && <span>{creator} packs</span>}
        </>;
    }
}

export default BookPackOriginatorLink;